import { render, staticRenderFns } from "./lobby-member.vue?vue&type=template&id=00bf0841&scoped=true&"
import script from "./lobby-member.vue?vue&type=script&lang=ts&"
export * from "./lobby-member.vue?vue&type=script&lang=ts&"
import style0 from "./lobby-member.vue?vue&type=style&index=0&id=00bf0841&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00bf0841",
  null
  
)

export default component.exports